<template>
  <el-dialog title="Cadastrar Visita" @open="iniciar" :visible.sync="visibility" :before-close="fechar" :close-on-click-modal="false" append-to-body width="45%" v-loading="loading">
    <el-form :model="visita" size="small" ref="form" :rules="validacao" label-position="top" style="margin: -20px 0px 0px 0px" hide-required-asterisk	:show-message="false">
      <el-row :gutter="10">
        <el-col :span="9">
          <el-form-item label="Data/Hora" prop="dataHora">
            <el-date-picker
              v-model="visita.dataHora"
              v-mask="'##/##/#### ##:##'"
              type="datetime"
              format="dd/MM/yyyy HH:mm"
              value-format="dd/MM/yyyy HH:mm"
              style="width: 100%"
            />
          </el-form-item>
        </el-col>
        <el-col :span="15">
          <el-form-item label="Cliente" style="width: 100%">
            <el-input :value="this.cliente.nome" readonly/>
          </el-form-item>
        </el-col>
      </el-row>      

      <el-row :gutter="24">
        <el-col :span="24">
          <el-form-item label="Atendente" style="width: 100%">
            <el-select
              v-model="visita.usuario"
              :remote-method="filtrarUsuariosSelect"
              :loading="loadingUsuarios"
              @focus="filtrarUsuariosSelect"
              value-key="id"
              placeholder=""
              loading-text="Carregando usuários"
              no-data-text="Nenhum usuário encontrado"
              filterable
              remote
              reserve-keyword
              style="width: 100%">
              <el-option v-for="item in usuariosDisponiveis" :key="item.id" :label="item.nome" :value="item">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="10" v-if="!this.visita.id" style="padding: 0px 0px;">
        <el-col :span="24">
          <el-form-item label="Adicionar Imóvel">
            <el-select v-model="imovelSelecionado"
              @change="adicionarImovelSelecionado"
              :remote-method="recuperarImoveisSelect"
              :loading="imovelSelectIsLoading"
              value-key="id"
              placeholder=""
              loading-text="Carregando imóveis"
              no-data-text="Nenhum imóvel encontrado"
              filterable
              remote
              reserve-keyword
              style="width: 100%">
              <el-option v-for="item in opcoesSelectImoveis" :key="item.id" :label="formatarEndereco(item)" :value="item"/>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row style="padding: 10px 0px;">
        <el-col :span="24" style="height: 100%">
          <el-container style="height: 100%">
            <el-main style="padding: 0px; height: 100%">
              <el-table
                :data="visita.imoveis" 
                empty-text="Nenhum imóvel selecionado"
                width="100%"
                height="135"
                size="small"
                style="background-color: #FFFFFF; border: solid 1px #DBDFE5; border-radius: 5px;"
                stripe
                highlight-current-row>
                <el-table-column label="Imóveis" prop="endereco">
                  <template slot-scope="scope">
                    <span>{{ formatarEndereco(scope.row) }}</span>
                  </template>
                </el-table-column>
                <el-table-column width="100">
                  <template slot-scope="scope">
                    <el-button @click.native.prevent="removerImovelSelecionado(scope.row)" type="text"  size="small"  style="padding: 0px; color: #F56C6C;">Remover</el-button>
                  </template>
                </el-table-column> 
              </el-table>
            </el-main>
          </el-container>
        </el-col>
      </el-row>
      
      <el-row :gutter="10">
        <el-col :span="24">
          <el-form-item label="Descrição">
            <el-input rows="4" type="textarea" v-model="visita.descricao"/>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button @click="gravarHandler" type="primary" size="small" round class="btn-box-shadow">Gravar</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import axios from 'axios';

import URLS from '../../../util/urls.js';
import { validadorDataHora, validadorHora } from '../../../util/validadores.js';
import util from '../../../util/funcoes.js';

export default {
  props: {
    visibility: Boolean,
    visitaSelecionada: Object
  },
  data() {
    return {
      validacao: {
        dataHora : [
          { validator: validadorDataHora, trigger: 'blur' },          
        ],
        hora: [
          { validator: validadorHora, required: true, message: "Hora inválida" },
        ]
      },
      imovelSelectIsLoading: false,
      loadingUsuarios: false,

      visita: {
        dataHora: util.agora(),
        descricao: "",
        imoveis: [],
        usuario: this.usuarioLogado
      },

      clientesDisponiveis: [],
      usuariosDisponiveis: [],
      opcoesSelectImoveis: [],

      imovelSelecionado: {},
    }
  },
    computed: {
    ...mapState('alugueisClientesStore', {
      cliente(state) { return state.clienteSelecionado },
    }),
    ...mapState('loginStore', {
      usuarioLogado: state => state.usuarioLogado
    }),

    loading() {
      return this.$store.state.loading;
    }
  },
  methods: {
    ...mapActions([
      'showLoading',
      'hideLoading'
    ]),
    ...mapActions('loginStore', [
      'relogar'
    ]),
    ...mapActions('alugueisClientesStore', [
      'gravarVisita'
    ]),
    iniciar() {
      this.reset();

      if(this.visitaSelecionada) {
        this.visita = this.visitaSelecionada;
        this.clientesDisponiveis = [this.visitaSelecionada.cliente];
        this.usuariosDisponiveis = [this.visitaSelecionada.usuario];
      }
    },
    reset() {
      this.visita = {
        dataHora: util.agora(),
        descricao: "",
        imoveis: [],
        usuario: this.usuarioLogado
      };
      this.opcoesSelectImoveis = [];
      this.usuariosDisponiveis = [this.usuarioLogado];
    },
    gravarHandler() {
      this.$refs['form'].validate((valid) => {
        if(valid){
          this.gravar();
        } else {
          this.exibirAlert("Atenção", "Preencha todos os campos obrigatórios");
        }
      })
    },
    gravar() {
      const payload = {
        ...this.visita,
        cliente: { id: this.cliente.id }
      };
      this.showLoading();

      this.gravarVisita(payload)
        .then(resultado => {
          switch(resultado.status) {
            case "SUCESSO":
              this.$message.success(resultado.mensagem);
              this.fechar();
              break;
            case "FALHA":
            case "ERRO":
              this.$message.warning(resultado.mensagem);
              this.fechar();
              break;
          }
        })
        .catch(() => {
          this.$message.error("Não foi possível conectar-se ao servidor");
        })
        .finally(() => {
          this.hideLoading();
        });
    },
    recuperarImoveisSelect(queryString) {
      const numberRegexPattern = /^\d+$/;
      const isPesquisaPorId = numberRegexPattern.test(queryString);

      const payload = {};
      if(isPesquisaPorId) {
        payload.idNaImobiliaria = queryString;
      } else {
        payload.endereco = queryString;
      }

      this.imovelSelectIsLoading = true;

      this.listarImoveis(payload)
        .then(resultado => {
          this.opcoesSelectImoveis = resultado.lista;
        })
        .catch(() => {
          this.opcoesSelectImoveis = [];
        })
        .finally(() => {
          this.imovelSelectIsLoading = false;
        });      
    },
    listarImoveis(payload) {
      return axios.post(URLS.IMOVEIS_LISTAR, payload)
        .then(response => {
          if(response.data.status === 'SESSAO_EXPIRADA') {
            return this.relogar()
              .then(authResponse => {
                if(authResponse.status === 'SUCESSO') {
                  return this.listarImoveis(payload);
                }
              });
          }

          return response.data;
        })
        .catch(error => { throw error });
    },
    filtrarUsuariosSelect(queryString) {
      if(queryString.type && queryString.type === 'focus') { queryString = '' }
      let payload = { nome: queryString }

      this.loadingUsuarios = true;
      axios.post(URLS.USUARIOS_LISTAR, payload)
        .then(response => {
          this.usuariosDisponiveis = response.data.lista;
          this.loadingUsuarios = false;
        })
        .catch(() => {
          this.usuariosDisponiveis = [];
          this.loadingUsuarios = false;
        });
    },    
    adicionarImovelSelecionado(imovel) {
      this.visita.imoveis.push(imovel);
      this.imovelSelecionado = {};
      this.opcoesSelectImoveis = [];
    },
    removerImovelSelecionado(imovel) {
      var i;
      for(i=0;i<this.visita.imoveis.length;i++){
        if(this.visita.imoveis[i].id == imovel.id){
          this.visita.imoveis.splice(i, 1);
        }
      }
    },
    formatarEndereco(imovel) {
      if(imovel){
        return "(" + imovel.idNaImobiliaria + ") " + imovel.endereco + (imovel.numeroEndereco ? ", " + imovel.numeroEndereco : "") + (imovel.bairro && imovel.cidade ? (", " + imovel.bairro.nome + " - " + imovel.cidade.nome) : "");
      } 
      return ""
    },
    fechar() {
      this.$emit('close');
    },
    exibirAlert(titulo, mensagem) {
      this.$alert(mensagem, titulo, { confirmButtonText: 'OK' });
    },
  }
}
</script>

